import { Global } from "@emotion/react"
import { globalStyles } from "@instacart/ipp-auth-service-tools"

export function GlobalStyle() {
  return <Global styles={globalStyles} />
}
